<template>
  <div class="main-page">
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid card pt-2 pb-3 justify-content-between">
          <div class="col">
            <div class="">
              <div class="text-3xl font-bold mt-2">
                E-Billing - Manage Customers
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-3 comp-grid">
            <div class="sticky-item">
              <div class="mb-4">
                <div class="surface-100 p-3 font-bold text-md">
                  Query Section
                </div>
                <form
                  ref="observer"
                  tag="form"
                  @submit.prevent="submitForm()"
                  class="mt-2 card"
                >
                  <div class="">
                    <div class="">
                      <div class="mb-2 font-bold text-sm">Account Number *</div>
                      <div id="ctrl-account_number">
                        <InputText
                          ref="ctrldigital_address"
                          v-model.trim="formData.account_number"
                          label="Account Number"
                          type="text"
                          pattern="^[A-Za-z0-9-]+$"
                          maxlength="12"
                          minlength="12"
                          :disabled="formData.inputFieldDisabled"
                          placeholder="Account Number"
                          class="w-full"
                          :class="getErrorClass('account_number')"
                        >
                        </InputText>
                        <small
                          v-if="isFieldValid('account_number')"
                          class="p-error"
                          >{{ getFieldError("account_number") }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="text-center my-3">
                    <Button
                      class="p-button-primary p-button-rounded"
                      type="submit"
                      label="Submit"
                      icon="pi pi-send"
                      v-if="!formData.pageData"
                      :loading="saving"
                    />
                    <Button
                      icon="pi pi-check"
                      label="Done"
                      class="p-button-rounded p-button-outlined p-button-success mx-1"
                      autofocus
                      v-if="formData.pageData"
                      @click="resetForm()"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-9 comp-grid">
            <div class="card" v-if="formData.pageData">

              {{ formData.pageData }}
            </div>
            <div
              v-else
              style="width: 100%; height: 70vh; background: rgb(235 235 235)"
            >
              <div class="py-4 m-auto text-center hidden-xs">
                <div v-if="saving">
                  <ProgressSpinner
                    style="width: 70px; height: 70px"
                    strokeWidth="1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, numeric } from "@/services/validators";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useEBillingPage } from "@/composables/ebillingpage.js";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  pageName: {
    type: String,
    default: "ebillingcustomers",
  },
  routeName: {
    type: String,
    default: "ebillingcustomers",
  },
  apiPath: {
    type: String,
    default: "ebilling/customers",
  },
  submitButtonLabel: {
    type: String,
    default: "Submit",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
});
const app = useApp();
const formDefaultValues = {
  pageData: null,
  inputFieldDisabled: false,
  account_number: "",
  account_name: "",
  mobile_1: "",
  mobile_2: "",
  email_1: "",
  email_2: "",
};
const formData = reactive({ ...formDefaultValues });
//form validation rules
const rules = computed(() => {
  return {
    account_number: { required },
  };
});
const v$ = useVuelidate(rules, formData); // form validation
const page = useEBillingPage({
  props,
  formData,
  v$,
  beforeSubmit,
  afterSubmit,
});
// perform custom validation before submit form
// set custom form fields
// return false if validation fails
function beforeSubmit() {
  Object.assign(formData, {
    pageData: null,
    statementChart: {},
    billingChart: {},
  });
  return true;
}
// after form submited to api
// reset form data.
// redirect to another page
function afterSubmit(response) {
  Object.assign(formData, { pageData: response, inputFieldDisabled: true });
}

function resetForm() {
  Object.assign(formData, { pageData: null, inputFieldDisabled: false });
}
//page state
const {
  submitted, // form submitted state - Boolean
  saving, // form api submiting state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page methods
const {
  submitForm, //submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;

onMounted(() => {
  const pageTitle = "E-Billing - Manage Customers";
  app.setPageTitle(props.routeName, pageTitle);
});
// expose page object for other components access
defineExpose({
  page,
});
</script>
<style scoped></style>
